/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersno1Inputs */

const en_partnersno1 = /** @type {(inputs: Partnersno1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const de_partnersno1 = /** @type {(inputs: Partnersno1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Partnersno1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersno1 = /** @type {((inputs?: Partnersno1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersno1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersno1(inputs)
	return de_partnersno1(inputs)
});
export { partnersno1 as "partnersNo" }